import { ChainId } from "./chainId";

export const LIQUIDITY_INFO = {
  [ChainId.Mainnet]: { token: "UNI-V2", exchange: "Uniswap" },
  [ChainId.Goerli]: { token: "UNI-V2", exchange: "Uniswap" },
  [ChainId.Hardhat]: { token: "UNI-V2", exchange: "Uniswap" },
  [ChainId.Binance]: { token: "Cake-LP", exchange: "PancakeSwap" },
};